// @flow
// import type { OptionsWithoutRender } from 'react-loadable';

import React from 'react';
import Loadable from 'react-loadable';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import { BUSINESS_999_URL_PATHS } from '../constants';
import Home from './Home';
//import Recent from './Recent';
import Search from './Search';
import Statistics from './Statistics';
import NotFound from './NotFound';
import Shop from './Shop';
import { get } from 'js-cookie';

export const getTokens = () => {
  const token = get('simpalsid.auth2');
  const auth = get('simpalsid.auth');
  const sessionKey = get('simpalsid.sessionKey');
  return { token, auth, sessionKey };
};

export const format999RedirectUrl = path => {
  if (typeof window === 'undefined') return null;

  const { token, auth, sessionKey } = getTokens();
  return `${path}?token=${token}&auth=${auth}&sessionKey=${sessionKey}`;
};

export const RedirectTo999 = path => {
  const RedirectComponent = () => {
    if (typeof window === 'undefined') return null;

    const { token, auth, sessionKey } = getTokens();
    window.location.href = `${path}?token=${token}&auth=${auth}&sessionKey=${sessionKey}`;
    return null;
  };
  return RedirectComponent;
};

// Loadable page common options
const AsyncPage = opts =>
  Loadable({
    // TODO: react-loadable passing error, retry props
    // make page specific loading placeholder
    // https://github.com/jamiebuilds/react-loadable#loadingcomponent
    loading: ({ pastDelay }) => (
      <LoadingPlaceholder height={500} pastDelay={pastDelay} />
    ),
    ...opts,
  });

const Adverts = AsyncPage({
  loader: () => import('./Adverts' /* webpackChunkName: 'page.adverts' */),
});

const Api = AsyncPage({
  loader: () => import('./Api' /* webpackChunkName: 'page.api' */),
});

const Trends = AsyncPage({
  loader: () => import('./Trends' /* webpackChunkName: 'page.trends' */),
});

const SearchAnalytics = AsyncPage({
  loader: () =>
    import(
      './Search/Analytics' /* webpackChunkName: 'page.search--analytics' */
    ),
});

const SearchAnalyticsCompare = AsyncPage({
  loader: () =>
    import(
      './Search/AnalyticsCompare' /* webpackChunkName: 'page.search--analytics-compare' */
    ),
});

const SearchQueries = AsyncPage({
  loader: () =>
    import('./Search/Queries' /* webpackChunkName: 'page.search--queries' */),
});

const StatisticsVisits = AsyncPage({
  loader: () =>
    import(
      './Statistics/Visits' /* webpackChunkName: 'page.statistics--visits' */
    ),
});

const StatisticsRepublish = AsyncPage({
  loader: () =>
    import(
      './Statistics/Republish' /* webpackChunkName: 'page.statistics--republish' */
    ),
});

//const Subscription = AsyncPage({
//  loader: () =>
//    import('./Subscription' /* webpackChunkName: 'page.subscription' */),
//});

const SubscribeBusiness = AsyncPage({
  loader: () =>
    import('./SubscribeBusiness' /* webpackChunkName: 'page.subscribe' */),
});

const SubscribePro = AsyncPage({
  loader: () =>
    import('./SubscribePro' /* webpackChunkName: 'page.subscribe.pro' */),
});

// const SubscribeProPeriod = AsyncPage({
//   loader: () =>
//     import(
//       './SubscribeProPeriod' /* webpackChunkName: 'page.subscribe.success' */
//     ),
// });

const SubscribeProPayment = AsyncPage({
  loader: () =>
    import(
      './SubscribeProPayment' /* webpackChunkName: 'page.subscribe.success' */
    ),
});

const SubscribeProSuccess = AsyncPage({
  loader: () =>
    import(
      './SubscribeProSuccess' /* webpackChunkName: 'page.subscribe.success' */
    ),
});

const SubscribeBusinessSuccess = AsyncPage({
  loader: () =>
    import(
      './SubscribeBusinessSuccess' /* webpackChunkName: 'page.subscribe.success' */
    ),
});

const Tariffs = AsyncPage({
  loader: () => import('./Tariffs' /* webpackChunkName: 'page.tariffs' */),
});

const BusinessFinance = AsyncPage({
  loader: () =>
    import(
      './Business/Finance' /* webpackChunkName: 'page.business--finance' */
    ),
});

const BusinessAccounts = AsyncPage({
  loader: () =>
    import(
      './Business/Accounts' /* webpackChunkName: 'page.business--accounts' */
    ),
});

const BusinessFunds = AsyncPage({
  loader: () =>
    import('./Business/Funds' /* webpackChunkName: 'page.business--funds' */),
});

const BusinessHistory = AsyncPage({
  loader: () =>
    import(
      './Business/History' /* webpackChunkName: 'page.business--history */
    ),
});

const BusinessEffectiveness = AsyncPage({
  loader: () =>
    import(
      './Business/Effectiveness' /* webpackChunkName: 'page.business--effectiveness */
    ),
});

const BusinessEffectivenessAdvanced = AsyncPage({
  loader: () =>
    import(
      './Business/EffectivenessAdvanced' /* webpackChunkName: 'page.business--effectiveness-advanced */
    ),
});

const FAQ = AsyncPage({
  loader: () => import('./FAQ' /* webpackChunkName: 'page.common--faq */),
});

const Discounts = AsyncPage({
  loader: () => import('./Discounts' /* webpackChunkName: 'page.discounts */),
});

const routes = [
  { path: '/', component: Home },
  /*   { path: '/', component: Recent }, */
  { path: '/analysis/search/', component: Search },
  {
    path: '/analysis/search/analytics/:queries',
    component: SearchAnalyticsCompare,
  },
  { path: '/shop/', component: Shop },

  // Analys Search group
  { path: '/analysis/trends/', component: Trends },
  { path: '/analysis/search/queries/', component: SearchQueries },
  { path: '/analysis/search/analytics/', component: SearchAnalytics },

  // Analys Site group
  { path: '/site/adverts/', component: Adverts },
  { path: '/site/statistics/visits/', component: StatisticsVisits },
  { path: '/site/statistics/republish/', component: StatisticsRepublish },

  // Business group
  { path: '/business/effectiveness/', component: BusinessEffectiveness },
  { path: '/business/finance/', component: BusinessFinance },
  {
    path: '/business/advanced-effectiveness/',
    component: BusinessEffectivenessAdvanced,
  },

  // Control group
  {
    path: '/control/accounts/',
    component: RedirectTo999(BUSINESS_999_URL_PATHS.CONNECTED_ACCOUNTS),
  },
  // { path: '/control/funds/', component: BusinessFunds },
  { path: '/control/history/', component: BusinessHistory },

  // Statistics group
  { path: '/analysis/statistics/', component: Statistics },
  //{ path: '/subscription/', component: Subscription },
  // { path: '/subscribe/business/', component: SubscribeBusiness },
  // { path: '/subscribe/pro/', component: SubscribePro },
  // { path: '/subscribe/business/success/', component: SubscribeBusinessSuccess },
  // { path: '/subscribe/pro/payment/', component: SubscribeProPayment },
  // { path: '/subscribe/pro/success/', component: SubscribeProSuccess },
  {
    path: '/tariffs/',
    component: RedirectTo999(BUSINESS_999_URL_PATHS.TARIFFS),
  },
  {
    path: '/discounts/',
    component: RedirectTo999(BUSINESS_999_URL_PATHS.DISCOUNTS),
  },

  // FAQ
  { path: '/faq/', component: FAQ },
  { path: '/api/', component: RedirectTo999(BUSINESS_999_URL_PATHS.API) },
];

export { NotFound };

export default routes;
